export default __webpack_public_path__ + "static/media/accessinfo.dcb20272.svg";